import { t } from 'ttag';

import {
    DOCUMENT_FIELDS_HINT,
    TAGS_HINT,
} from '../../services/documentFields/constants';
import { PermissionCategory } from '../proRateInfoPopup/proRateInfoPopupTypes';
import { MenuID } from './changeDocumentPopupTypes';

export enum MenuItems {
    INFO = 'info',
    ORDER = 'order',
    SIGNERS = 'signers',
    VIEWERS = 'viewers',
    REVIEWERS = 'reviewers',
    TEMPLATES = 'templates',
    TAGS = 'tags',
    EXTRA_FIELDS = 'extraFields',
}

export const MENU_ITEMS: {
    id: MenuID;
    title: string;
    enabled: boolean;
    hint?: string;
    permission?: PermissionCategory;
}[] = [
    {
        id: MenuItems.INFO,
        title: t`Загальні реквізити`,
        enabled: true,
    },
    {
        id: MenuItems.ORDER,
        title: t`Тип документів`,
        enabled: true,
    },
    {
        id: MenuItems.SIGNERS,
        title: t`Підписання співробітниками`,
        enabled: true,
    },
    {
        id: MenuItems.VIEWERS,
        title: t`Доступ співробітників`,
        enabled: true,
    },
    {
        id: MenuItems.REVIEWERS,
        title: t`Внутрішнє погодження`,
        enabled: true,
        permission: PermissionCategory.REVIEWS,
    },
    {
        id: MenuItems.TEMPLATES,
        title: t`Сценарій опрацювання`,
        enabled: true,
        permission: PermissionCategory.TEMPLATES,
    },
    {
        id: MenuItems.TAGS,
        enabled: true,
        title: t`Ярлики`,
        hint: TAGS_HINT,
        permission: PermissionCategory.TAGS,
    },
    {
        id: MenuItems.EXTRA_FIELDS,
        title: t`Додаткові параметри`,
        enabled: true,
        hint: DOCUMENT_FIELDS_HINT,
        permission: PermissionCategory.ADDITIONAL_FIELDS,
    },
];

export const EDITABLE_INFO_STATUSES = [
    'UPLOADED',
    'READY',
    'SIGNED',
    'SENT',
    'SIGNED_AND_SENT',
    'APPROVED',
];

export const SINGLE_DOCUMENT_MENU_ITEMS: MenuID[] = [
    MenuItems.INFO,
    MenuItems.ORDER,
    MenuItems.EXTRA_FIELDS,
];
